import { render, staticRenderFns } from "./ForPsychologist.vue?vue&type=template&id=6da11efb&"
import script from "./ForPsychologist.vue?vue&type=script&lang=js&"
export * from "./ForPsychologist.vue?vue&type=script&lang=js&"
import style0 from "./ForPsychologist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports